import { Box, TextField, Typography } from "@mui/material";
import { useStyles } from "../styles";
import { useStepperData } from "../../../Helpers/Contexts/stepperContext";
import { REGEX } from "../../../Helpers/constant";

const JourneyWithMCA = () => {
  const classes = useStyles();
  const { formData, updateFormData } = useStepperData();

  const handleExperienceChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    if (REGEX.NUMBERWITHDECIMAL2.test(value)) {
      updateFormData("Experience_at_MCA_In_Years__c", value);
    }
  };

  return (
    <>
      <Typography
        variant="h1"
        className={`${classes.headerTitle} label required`}
        mb={2}
      >
        Your journey with MCA
      </Typography>
      <Typography className={classes.headerDescription} mb={4}>
        How many years have you been with the Mumbai Cricket Association? (in
        years)
      </Typography>
      <TextField
        fullWidth
        placeholder="Years of experience (in years)"
        value={formData.Experience_at_MCA_In_Years__c || ""}
        onChange={handleExperienceChange}
      />
    </>
  );
};

export default JourneyWithMCA;
